// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1-vlf","label":"CategoryService_label__24tan","location":"CategoryService_location__1d1aO"};